import "./Inventory.scss";
import React from "react";
import axios from "axios";
import ModalDelete from "../ModalDelete/ModalDelete";
//import of icons
import searchIcon from "../../assets/Icons/search-24px.svg";
import sortIcon from "../../assets/Icons/sort-24px.svg";
import chevronRight from "../../assets/Icons/chevron_right-24px.svg";
import deleteIcon from "../../assets/Icons/delete_outline-24px.svg";
import editIcon from "../../assets/Icons/edit-24px.svg";
import { Link } from "react-router-dom";

const fullInventoryURL =
  "https://instock-api-rbht.onrender.com/api/v1/inventories";
const specificWarehouseURL =
  "https://instock-api-rbht.onrender.com/api/v1/warehouseInventories/";

let status = "inventory__card-item--inStock";
class Inventory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      warehouseInventories: [],
      selectedWarehouseInventory: [],
      show: false,
      target: "inventory",
      id: "",
      name: "",
    };
    // Bind this to function hide / show modal so it's assigned to the state
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount() {
    this.getInventoryData();
  }

  getInventoryData() {
    axios
      .get(fullInventoryURL)
      .then((response) => {
        // console.log(response.data);
        this.setState({ warehouseInventories: response.data });
      })
      .then(() => {
        const warehouseInventory = this.state.warehouseInventories.filter(
          (inventory) => inventory.warehouseID === this.props.match.params.id
        );
        // console.log(warehouseInventory);
        this.setState({ selectedWarehouseInventory: warehouseInventory });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //get the specific warehouse's inventory using their ID
  getWarehouseInventoryById(id) {
    axios
      .get(specificWarehouseURL + this.props.match.params.id)
      .then((response) => {
        console.log(response);
        this.setState({ selectedWarehouseInventory: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // function to call to show modal
  showModal = (id, name) => {
    this.setState({ show: true });
    this.setState({ id: id });
    this.setState({ name: name });
  };
  // function to call to hide modal
  hideModal = () => {
    this.setState({ show: false });
  };

  render() {
    return (
      <>
        <div className="backgroundInvent">
          <section className="inventory">
            <div className="inventory__heading-container">
              <h1 className="inventory__title">Inventory</h1>
              <div className="inventory__sub-container">
                <div className="inventory__sub-container--search">
                  <img
                    className="inventory__search-icon"
                    src={searchIcon}
                    alt="search icon"
                  ></img>
                  <input
                    className="inventory__search"
                    type="search"
                    name="search"
                    placeholder="Search..."
                  ></input>
                </div>
                <Link to="/inventory/new">
                  <button className="CTA-button">+ Add New Item</button>
                </Link>
              </div>
            </div>
            {/* nav heading for inventory list */}
            <div className="inventory__nav">
              <div className="inventory__nav-container">
                <div className="inventory__nav-sub-container individualItem">
                  <p className="inventory__nav-heading">
                    Inventory item
                    <img
                      className="inventory__sort-icon"
                      src={sortIcon}
                      alt="sort icon"
                    ></img>
                  </p>
                </div>
                <div className="inventory__nav-sub-container category">
                  <p className="inventory__nav-heading">
                    category
                    <img
                      className="inventory__sort-icon"
                      src={sortIcon}
                      alt="sort icon"
                    ></img>
                  </p>
                </div>
                <div className="inventory__nav-sub-container status">
                  <p className="inventory__nav-heading">
                    status
                    <img
                      className="inventory__sort-icon"
                      src={sortIcon}
                      alt="sort icon"
                    ></img>
                  </p>
                </div>
                <div className="inventory__nav-sub-container quantity">
                  <p className="inventory__nav-heading">
                    qty
                    <img
                      className="inventory__sort-icon"
                      src={sortIcon}
                      alt="sort icon"
                    ></img>
                  </p>
                </div>
                <div className="inventory__nav-sub-container warehouse">
                  <p className="inventory__nav-heading">
                    warehouse
                    <img
                      className="inventory__sort-icon"
                      src={sortIcon}
                      alt="sort icon"
                    ></img>
                  </p>
                </div>
                <div className="inventory__nav-sub-container action">
                  <p className="inventory__nav-heading">actions</p>
                </div>
              </div>
            </div>
            {/* inventory card - can be made into separate component to take props */}
            {this.state.warehouseInventories.map((inventory, index) => {
              if (inventory.status === "In Stock") {
                status = "inventory__card-item--inStock";
              } else {
                status = "inventory__card-item--outStock";
              }
              return (
                <div className="inventory__card-wrapper" key={inventory.id}>
                  <div className="inventory__card">
                    <Link
                      to={`inventory/details/${inventory.id}`}
                      className="inventory__card-item inventory__item-container individualItem"
                    >
                      <h3 className="inventory__card-mobile-heading">
                        Inventory item
                      </h3>
                      <p className="inventory__card-item--item">
                        {inventory.itemName}
                        <img
                          className="inventory__item-icon"
                          src={chevronRight}
                          alt="chevron"
                        ></img>
                      </p>
                    </Link>

                    <div className="inventory__card-item category">
                      <h3 className="inventory__card-mobile-heading">
                        category
                      </h3>
                      <p className="inventory__card-item--electronic">
                        {inventory.category}
                      </p>
                    </div>

                    <div className="inventory__card-item status">
                      <h3 className="inventory__card-mobile-heading">status</h3>
                      <p className={status}>{inventory.status}</p>
                    </div>

                    <div className="inventory__card-item quantity">
                      <h3 className="inventory__card-mobile-heading">qty</h3>
                      <p className="inventory__card-item--quantity">
                        {inventory.quantity}
                      </p>
                    </div>

                    <div className="inventory__card-item warehouse">
                      <h3 className="inventory__card-mobile-heading">
                        warehouse
                      </h3>
                      <p className="inventory__card-item--warehouse">
                        {inventory.warehouseName}
                      </p>
                    </div>

                    <div className="inventory__card-item inventory__action-container action">
                      <img
                        className="inventory__action-icon inventory__action-icon--delete"
                        src={deleteIcon}
                        alt="delete icon"
                        onClick={() =>
                          this.showModal(inventory.id, inventory.itemName)
                        }
                      ></img>
                      <Link to={`/inventory/edit/${inventory.id}`}>
                        <img
                          className="inventory__action-icon inventory__action-icon--edit"
                          src={editIcon}
                          alt="edit icon"
                        ></img>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </section>
        </div>
        <ModalDelete
          show={this.state.show}
          handleClose={this.hideModal}
          target={this.state.target}
          id={this.state.id}
          name={this.state.name}
        />
      </>
    );
  }
}

export default Inventory;
